import { RacwaTextInput, RacwaTextInputProps } from "@racwa/react-components";

export interface RacwaNameInputProps extends RacwaTextInputProps {}

const RacwaNameInput = ({ ...props }: RacwaNameInputProps) => {
  return <RacwaTextInput type="text" {...props} />;
};

export default RacwaNameInput;
